import StyledDrawer from 'Components/StyledDrawer'
import { isPtaBannerVisible } from 'Services/common/Features/Authority/Context/utils'
import useTypedSelector from 'Store'
import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

interface DynamicDrawerMenuProps {
  drawerMenuContent: ReactNode
}

function DynamicDrawerMenu({ drawerMenuContent }: Readonly<DynamicDrawerMenuProps>) {
  const { user } = useTypedSelector(state => state.user)
  const location = useLocation()
  return (
    <StyledDrawer
      isPtaBannerVisible={isPtaBannerVisible(user, location)}
      variant="permanent"
      open={true}
    >
      {drawerMenuContent}
    </StyledDrawer>
  )
}

export { DynamicDrawerMenu }
